import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColumnPreferenceService {

  private storageKey(userId: string, component: string) {
    return `cols_${component}_${userId}`;
  }

  save(userId: string, component: string, fields: string[]): void {
    localStorage.setItem(this.storageKey(userId, component), JSON.stringify(fields));
  }

  load(userId: string, component: string): string[] | null {
    const raw = localStorage.getItem(this.storageKey(userId, component));
    return raw ? JSON.parse(raw) : null;
  }

  clear(userId: string, component: string): void {
    localStorage.removeItem(this.storageKey(userId, component));
  }

  reconcile(saved: string[], roleColumns: string[]): string[] {
    return saved.filter(f => roleColumns.includes(f));
  }
}
